// This PC (decision 065): the technical page of the companion, with its
// tabs: the facts and the session, the settings, the log, the returns
// waiting to be sent. Under the host alone.

import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

import { NotOnThisPc } from "@/components/NotOnThisPc";
import { useHost } from "@/host/host";

export const Route = createFileRoute("/pc")({
  component: ThisPcLayout,
});

function ThisPcLayout() {
  const host = useHost();
  if (!host) return <NotOnThisPc />;
  return (
    <div className="space-y-5">
      <nav className="tabs" aria-label="This PC">
        <Link to="/pc" className="tab" activeOptions={{ exact: true }} activeProps={{ className: "tab tab-active" }} data-testid="pc-tab-overview">
          This PC
        </Link>
        <Link to="/pc/log" className="tab" activeProps={{ className: "tab tab-active" }} data-testid="pc-tab-log">
          Log
        </Link>
        <Link to="/pc/returns" className="tab" activeProps={{ className: "tab tab-active" }} data-testid="pc-tab-returns">
          Returns waiting
        </Link>
      </nav>
      <Outlet />
    </div>
  );
}
